import {createContext, useContext, FC, ReactNode} from 'react';

interface ConfigContextProps {
  bugsnagApiKey?: string;
}

interface ConfigProviderProps {
  bugsnagApiKey?: string;
  children: ReactNode;
}

const BugsnagConfigContext = createContext<ConfigContextProps | undefined>(undefined);

export const useBugsnagConfig = () => {
  const context = useContext(BugsnagConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

const BugsnagConfigProvider: FC<ConfigProviderProps> = ({ bugsnagApiKey, children }) => {
  return (
    <BugsnagConfigContext.Provider value={{ bugsnagApiKey }}>
      {children}
    </BugsnagConfigContext.Provider>
  );
};

export default BugsnagConfigProvider;
